// @flow
import _ from 'lodash'

type Callback = () => void

export default class {
  debouncedOnChange: Function
  callbacks: Array<Callback>

  constructor(delayTime: number) {
    this.debouncedOnChange = _.debounce(() => this.changed(), delayTime)
    this.callbacks = []
  }

  onChange(callback: Callback) {
    this.callbacks.push(callback)
  }

  changed() {
    _.each(this.callbacks, (callback: Callback) => callback())
  }
}
